import { RootEpic } from "../../../store/epics";
import { isActionOf} from 'typesafe-actions';
import {
    from,
      filter,
      switchMap,
      of,
} from 'rxjs';
import { loginAction, loginContractorAction, loginRequestAction, logoutAction, signUpAction } from "./actions";
import { pushRoute } from "../../app/store/actions";
import { ROUTES } from "../../../history";


const loginRequestEpic: RootEpic = action$ => 
    action$.pipe(
        filter(isActionOf(loginRequestAction)),
        switchMap(({payload}) => {
            if(payload.role) {
                return of(loginContractorAction.request(payload as Required<typeof payload>))
            }
            return of(loginAction.request(payload));
        }),
    )


const loginEpic: RootEpic = (action$, state$,{api}) => 
    action$.pipe(
        filter(isActionOf(loginAction.request)),
        switchMap(({payload}) => {
          return from(api.login({}, {Authorization: ''}, payload))
            .pipe(
                switchMap(res => {
                    const ret = [];
                    if(res.code === 200 || res.code === 201) {
                        api.setToken(res.data!.data.token);
            
                      ret.push(loginAction.success(res.data!.data));
                      ret.push(pushRoute({route: ROUTES.ADMIN_DASHBOARD}))
                    }
                   else  ret.push(loginAction.failure(res));
                   return ret;
                })
            )
        })
    );


const signUpEpic: RootEpic = (action$, state$,{api}) => 
    action$.pipe(
        filter(isActionOf(signUpAction.request)),
        switchMap(({payload}) => {
          return from(api.login({}, {}, payload))
            .pipe(
                switchMap(res => {
                    const ret = [];
                    if(res.code === 200 || res.code === 201) {
                        api.setToken(res.data!.data.token);
                        ret.push(signUpAction.success(res.data!.data));
                        ret.push(pushRoute({route: ROUTES.ADMIN_DASHBOARD}))
                   
                    }
                   else ret.push(signUpAction.failure(res))
                   return ret;
                })
            )
        })
    );

    const loginContractorEpic: RootEpic = (action$, state$,{api}) => 
    action$.pipe(
        filter(isActionOf(loginContractorAction.request)),
        switchMap(({payload}) => {
          return from(api.contractorLogin({}, {Authorization: ''}, {
            Email: payload.email,
            Password: payload.password,
            Role: payload.role,
            source: 'web'
          }))
            .pipe(
                switchMap(res => {
                    const ret = [];
                    if(res.code === 200 || res.code === 201) {
                        api.setToken(res.data!.token);
                      ret.push(loginContractorAction.success(res.data!));
                      ret.push(pushRoute({route: ROUTES.CONTRACTOR_DASHBOARD}))
                    }
                   else  ret.push(loginContractorAction.failure(res));
                   return ret;
                })
            )
        })
    );

    const logoutEpic: RootEpic = (action$, state$,{api}) => 
    action$.pipe(
        filter(isActionOf(logoutAction.request)),
        switchMap(({payload}) => {
          return from(api.logout({}, {},  payload))
            .pipe(
                switchMap(res => {
                    const ret = [];
                    if(res.code === 200 || res.code === 201) {
                        
                    
                      ret.push(pushRoute({route: ROUTES.ROOT}))
                      ret.push(logoutAction.success(res.data!));
                    }
                   else {
                    ret.push(pushRoute({route: ROUTES.ROOT}))
                     ret.push(loginContractorAction.failure(res));}
                   return ret;
                })
            )
        })
    );



 const AuthEpics = [
    loginRequestEpic,
    loginEpic,
    signUpEpic,
    loginContractorEpic,
    logoutEpic,
];

export default AuthEpics;